import {Axis} from '@visx/xychart';
import React from 'react';

import {TickLabelFormatter} from 'ui-library/charting/internals/utils/getTickLabelFormatter';

export interface BaseAxisProps {
  label?: string;
  suggestedNumTicks: number;
  tickLabelFormatter: TickLabelFormatter;
}
export type XAxisProps = BaseAxisProps & {
  tickLabelRotation: number;
};

export function XAxis(props: XAxisProps): JSX.Element {
  return (
    <Axis
      hideTicks={true}
      label={props.label}
      numTicks={props.suggestedNumTicks}
      orientation="bottom"
      tickFormat={props.tickLabelFormatter}
      tickLabelProps={() =>
        props.tickLabelRotation !== 0
          ? {
              angle: -props.tickLabelRotation,
              textAnchor: 'end',
            }
          : {}
      }
    />
  );
}

export function YAxis(props: BaseAxisProps): JSX.Element {
  return (
    <Axis
      hideTicks={true}
      label={props.label}
      numTicks={props.suggestedNumTicks}
      orientation="left"
      tickFormat={props.tickLabelFormatter}
    />
  );
}
